module.exports = __webpack_public_path__ + "static/img/g_3.00b663a1.png";